import script from "./SentimentExplorerTab.vue?vue&type=script&setup=true&lang=js"
export * from "./SentimentExplorerTab.vue?vue&type=script&setup=true&lang=js"

import "./SentimentExplorerTab.vue?vue&type=style&index=0&id=00df252c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00df252c"]])

export default __exports__